import React, { Component } from 'react';
import Icon from '../icon/Icon';
import './navbar.scss';

const defaultProps = {
  back: true,
  title: '',
  leftContent: '',
  rightContent: ''
};

export default class Navbar extends Component {
  back() {
    if (typeof this.props.onBack === 'function') {
      this.props.onBack();
    } else {
      window.history.back();
    }
  }

  render() {
    const {
      back,
      title,
      leftContent,
      rightContent
    } = this.props;

    return (
      <div className="navbar">
        <div className="navbar-left" onClick={() => this.back()}>
          {
            back ? (
              <Icon
                icon="fanhui"
                className="navbar-icon"
              />
            ) : ''
          }
          {
            !back && leftContent ? leftContent : ''
          }
        </div>
        <div className="navbar-title">
          {title}
        </div>
        <div className="navbar-right">
          {
            rightContent || ''
          }
        </div>
      </div>
    );
  }
}

Navbar.defaultProps = defaultProps;
